// Self-hosted logo (no external CDN dependency, works on any domain incl. nashaadria.com)
const LOGO_URL = "/logo-512.png";

export default function Logo({ size = 56, withText = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className="shrink-0 flex items-center justify-center"
        style={{ height: size, width: size }}
      >
        <img
          src={LOGO_URL}
          alt="NAŠA Myner Adria"
          width={size}
          height={size}
          style={{
            height: size,
            width: size,
            objectFit: "contain",
            imageRendering: "auto",
            filter: "drop-shadow(0 0 6px rgba(34,255,119,0.25))",
          }}
          draggable={false}
        />
      </div>
      {withText && (
        <div className="leading-tight">
          <div className="font-display text-xl font-bold tracking-wide">
            <span className="text-neon-green">NAŠA</span>{" "}
            <span className="text-neon-orange">MYNER</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            Adria Region · Giveaway
          </div>
        </div>
      )}
    </div>
  );
}
